import { useMutation } from 'react-query';
import { useSnackbar } from 'hooks';
import { updateCompanyTaxId } from 'api/taxIdService';

export const useUpdateCompanyTaxId = () => {
  const errorMessage =
    'Something went wrong while updating the company tax id, please try again later.';
  const setSnackbar = useSnackbar();

  return useMutation({
    mutationFn: updateCompanyTaxId,
    onError: (error) => {
      const errorResponse = error as {
        message?: string;
      };
      setSnackbar({
        message: errorResponse?.message || errorMessage,
        severity: 'error',
      });
    },
  });
};
